import { theme as baseTheme, createTheme } from '@shared/components';

import Sidebar from './sidebar/sidebar';

const examManagementTheme = {
  components: {
    ...Sidebar,
    MuiCssBaseline: {
      styleOverrides: {
        'mark.search-highlight': {
          backgroundColor: '#FEF08A',
          borderRadius: '3px',
          padding: '0 1px',
          fontStyle: 'normal',
        },
      },
    },
  },
};

export const theme = createTheme(baseTheme, examManagementTheme);
